var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoupons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 2.91602L15 1.66602L13.75 2.91602L12.5 1.66602L11.25 2.91602L10 1.66602L8.75 2.91602L7.5 1.66602L6.25 2.91602L5 1.66602L3.75 2.91602L2.5 1.66602V18.3327L3.75 17.0827L5 18.3327L6.25 17.0827L7.5 18.3327L8.75 17.0827L10 18.3327L11.25 17.0827L12.5 18.3327L13.75 17.0827L15 18.3327L16.25 17.0827L17.5 18.3327V1.66602L16.25 2.91602ZM15.8333 15.9077H4.16667V4.09102H15.8333V15.9077ZM5 12.4993H15V14.166H5V12.4993ZM5 9.16602H15V10.8327H5V9.16602ZM5 5.83268H15V7.49935H5V5.83268Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoupons);
export default __webpack_public_path__ + "static/media/coupons.4258b929db0d18e3434dc14bfeb0c378.svg";
export { ForwardRef as ReactComponent };